import { Component, OnInit, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.css']
})
export class RichTextEditorComponent implements OnInit {

  @Input() styles: string;
  @Input() content: string;
  @Output() onContentChanged: BehaviorSubject<any>;

  constructor() {
    this.onContentChanged = new BehaviorSubject({});
  }

  ngOnInit() {
  }

  onChanged(data: any) {
    this.onContentChanged.next(data);
  }

}
